import Sandbox from 'websandbox';

export function execute(code, context) {
    return new Promise((resolve, reject) => {
        if (!code) return reject('No code provided for execution');

        const sandbox = Sandbox.create(
            {},
            {
                frameContainer: 'body',
                frameClassName: 'web5-sandboxCode__iframe',
            },
        );

        sandbox.promise
            .then(() =>
                sandbox.run(`
                    var exports = {};
                    ${code};
                    Websandbox.connection.setLocalApi(exports);
                `),
            )
            .then(() => sandbox.connection.remote.handler(context))
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                console.error(err);
                reject(err);
            })
            .then(() => {
                sandbox.destroy();
            });
    });
}
